import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/routes/paths';

/** Blocks dashboard when user must change password first. */
export function MustChangePasswordRoute() {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to={ROUTES.login} replace />;
  }

  if (user.mustChangePassword) {
    return <Navigate to={ROUTES.changePassword} replace />;
  }

  return <Outlet />;
}
